import { Controller } from "@hotwired/stimulus"

// Автоотправка GET-формы фильтра.
// submit          — сразу (например, change на select).
// debouncedSubmit — с задержкой (например, input в поисковой строке).
export default class extends Controller {
  static values = { delay: { type: Number, default: 250 } }

  submit() {
    this.element.requestSubmit()
  }

  debouncedSubmit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
